import { Component, OnInit } from '@angular/core';
import { apiService } from '../../../../service/api.service'
import { DetalleConsultaModel, ResponseDetalleConsultaModel } from '../../../../model/Contacto.model'
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { StorageService } from 'src/app/service/storage.service';
@Component({
  selector: 'app-detalle-consulta',
  templateUrl: './detalle-consulta.component.html',
  styleUrls: ['./detalle-consulta.component.css']
})
export class DetalleConsultaComponent implements OnInit {
  detalleConsulta = new DetalleConsultaModel();
  formObservacion: FormGroup;
  cargando = true;
  constructor(
    private api: apiService,
    public storageService: StorageService,
  ) { }

  ngOnInit(): void {
    this.getDetalle();
    this.formObservacion = new FormGroup({
      respuesta: new FormControl('', [Validators.required]),  
    });
  }

  hasError (controlName: string, errorName: string){
    return this.formObservacion.controls[controlName].hasError(errorName);
  }

  getDetalle(){
    this.api.API_POST_obtenerDetalleForo().subscribe((response : ResponseDetalleConsultaModel) => {
      this.detalleConsulta = response.payload;
      this.cargando = false;
    },
    (err) => {
      console.log(err)
    })
  }

  enviarObservacion(formObservacionValue){
    if (this.formObservacion.valid) {
      formObservacionValue.idForo = this.api.idForo;
      formObservacionValue.idUsuario = this.storageService.getCurrentUser().idUsuario; 
      this.api.API_POST_enviarRespuestaForo(formObservacionValue).subscribe((response) => {
        this.getDetalle();
      },
      (err) => {
        console.log(err)
      })
    }
  }

  irA(){
    this.api.activeTabContacto = 1;
    this.api.emitDireccionamiento('contacto');
  }

}
